import React from "react";
import { Container, Typography, Box } from "@material-ui/core";

function TermsOfServiceConsumer() {
  return (
    <div style={{ backgroundColor: "#fffdf8", minHeight: "100vh", width: "100%", fontFamily: "'Lato', sans-serif" }}>
      <Container style={{ padding: "40px 20px", maxWidth: "1000px" }}>
        <Box mb={4} textAlign="center">
          <Typography style={{ paddingTop: "80px", fontFamily: "'Lato', sans-serif", fontWeight: "bold", fontSize: "80px" }} variant="h3" gutterBottom>
            Terms of Service
          </Typography>
          <Typography variant="subtitle1" color="textSecondary">
            Effective Date: February 25, 2025
          </Typography>
        </Box>

        <Box mb={3}>
          <Typography style={{fontFamily: "'Playfair-Display, serif", fontSize:'21px', fontWeight: 500,WebkitFontSmoothing: "antialiased",MozOsxFontSmoothing: "grayscale",}} paragraph>
            Welcome to Wolfe (“Wolfe,” “we,” “our,” or “us”). Wolfe provides AI-powered mental health support services to help users improve their well-being. By using our services, you agree to abide by these Terms of Service (“Terms”). If you do not agree to these Terms, please do not use our services.
          </Typography>
        </Box>

        <Box mb={3}>
          <Typography style={{ fontFamily: "'Lato', sans-serif", fontWeight: 600, fontSize: "25px" }} variant="h5" gutterBottom>
            1. Who Can Use Our Services
          </Typography>
          <ul>
            <li><Typography style={{fontFamily: "'Playfair-Display, serif", fontSize:'21px', fontWeight: 500,WebkitFontSmoothing: "antialiased",MozOsxFontSmoothing: "grayscale",}}><strong>You must be at least 18 years old</strong> or the minimum legal age in your jurisdiction to use Wolfe.</Typography></li>
            <li><Typography style={{fontFamily: "'Playfair-Display, serif", fontSize:'21px', fontWeight: 500,WebkitFontSmoothing: "antialiased",MozOsxFontSmoothing: "grayscale",}}><strong>By using Wolfe,</strong> you confirm that you have the legal capacity to enter into this agreement.</Typography></li>
          </ul>
        </Box>

        <Box mb={3}>
          <Typography style={{ fontFamily: "'Lato', sans-serif", fontWeight: 600, fontSize: "25px" }} variant="h5" gutterBottom>
            2. Account Creation and Access
          </Typography>
          <ul>
            <li><Typography style={{fontFamily: "'Playfair-Display, serif", fontSize:'21px', fontWeight: 500,WebkitFontSmoothing: "antialiased",MozOsxFontSmoothing: "grayscale",}}>You may need to create an account to access certain features of Wolfe.</Typography></li>
            <li><Typography style={{fontFamily: "'Playfair-Display, serif", fontSize:'21px', fontWeight: 500,WebkitFontSmoothing: "antialiased",MozOsxFontSmoothing: "grayscale",}}>You must provide accurate and complete information when creating your account.</Typography></li>
            <li><Typography style={{fontFamily: "'Playfair-Display, serif", fontSize:'21px', fontWeight: 500,WebkitFontSmoothing: "antialiased",MozOsxFontSmoothing: "grayscale",}}>You are responsible for maintaining the confidentiality of your login credentials.</Typography></li>
            <li><Typography style={{fontFamily: "'Playfair-Display, serif", fontSize:'21px', fontWeight: 500,WebkitFontSmoothing: "antialiased",MozOsxFontSmoothing: "grayscale",}}>If you suspect unauthorized access to your account, notify us immediately at support@hellowolfe.com</Typography></li>
          </ul>
        </Box>

        <Box mb={3}>
          <Typography style={{ fontFamily: "'Lato', sans-serif", fontWeight: 600, fontSize: "25px" }} variant="h5" gutterBottom>
            3. Use of Our Services
          </Typography>
          <Typography style={{fontFamily: "'Playfair-Display, serif", fontSize:'21px', fontWeight: 500,WebkitFontSmoothing: "antialiased",MozOsxFontSmoothing: "grayscale",}} paragraph>
            You may use Wolfe only for personal, non-commercial mental health support. You agree not to:
          </Typography>
          <ul>
          <li><Typography style={{fontFamily: "'Playfair-Display, serif", fontSize:'21px', fontWeight: 500,WebkitFontSmoothing: "antialiased",MozOsxFontSmoothing: "grayscale",}}>Violate any applicable laws or regulations.</Typography></li>
            <li><Typography style={{fontFamily: "'Playfair-Display, serif", fontSize:'21px', fontWeight: 500,WebkitFontSmoothing: "antialiased",MozOsxFontSmoothing: "grayscale",}}>Use Wolfe for medical diagnosis, emergency situations, or crisis intervention.</Typography></li>
            <li><Typography style={{fontFamily: "'Playfair-Display, serif", fontSize:'21px', fontWeight: 500,WebkitFontSmoothing: "antialiased",MozOsxFontSmoothing: "grayscale",}}>Misuse, hack, or disrupt our platform, AI services, or user experience.</Typography></li>
            <li><Typography style={{fontFamily: "'Playfair-Display, serif", fontSize:'21px', fontWeight: 500,WebkitFontSmoothing: "antialiased",MozOsxFontSmoothing: "grayscale",}}>Share false, misleading, or inappropriate content.            </Typography></li>
          </ul>
        </Box>
        <Box mb={3}>
  <Typography style={{ fontFamily: "'Lato', sans-serif", fontWeight: 600, fontSize: "25px" }} variant="h5" gutterBottom>
    4. AI-Generated Content & Limitations
  </Typography>
  <Typography style={{ fontFamily: "'Playfair-Display, serif", fontSize: "21px", fontWeight: 500, WebkitFontSmoothing: "antialiased", MozOsxFontSmoothing: "grayscale" }} paragraph>
    Wolfe uses AI to provide mental health guidance, but it is not a substitute for professional therapy, medical advice, or crisis intervention. You acknowledge that:
  </Typography>
  <ul>
    <li><Typography style={{ fontFamily: "'Playfair-Display, serif", fontSize: "21px", fontWeight: 500, WebkitFontSmoothing: "antialiased", MozOsxFontSmoothing: "grayscale" }}>AI-generated responses may not always be accurate, reliable, or appropriate for your specific situation. </Typography></li>
    <li>
      <Typography style={{ fontFamily: "'Playfair-Display, serif", fontSize: "21px", fontWeight: 500, WebkitFontSmoothing: "antialiased", MozOsxFontSmoothing: "grayscale" }}>
        If you are experiencing a mental health crisis or medical emergency, seek professional help immediately.
      </Typography>
    </li>
  </ul>
</Box>

<Box mb={3}>
  <Typography style={{ fontFamily: "'Lato', sans-serif", fontWeight: 600, fontSize: "25px" }} variant="h5" gutterBottom>
    5. Data Privacy & Security
  </Typography>
  <Typography style={{ fontFamily: "'Playfair-Display, serif", fontSize: "21px", fontWeight: 500, WebkitFontSmoothing: "antialiased", MozOsxFontSmoothing: "grayscale" }} paragraph>
    Our Privacy Policy explains how we collect, store, and use your data. By using Wolfe, you agree to our Privacy Policy.
  </Typography>
  <ul>
    <li>
      <Typography style={{ fontFamily: "'Playfair-Display, serif", fontSize: "21px", fontWeight: 500, WebkitFontSmoothing: "antialiased", MozOsxFontSmoothing: "grayscale" }}>
        Wolfe implements end-to-end encryption to protect user data.
      </Typography>
    </li>
    <li>
      <Typography style={{ fontFamily: "'Playfair-Display, serif", fontSize: "21px", fontWeight: 500, WebkitFontSmoothing: "antialiased", MozOsxFontSmoothing: "grayscale" }}>
        We do not use user interactions to train AI models.
      </Typography>
    </li>
  </ul>
</Box>

<Box mb={3}>
  <Typography style={{ fontFamily: "'Lato', sans-serif", fontWeight: 600, fontSize: "25px" }} variant="h5" gutterBottom>
    6. Fees and Payments
  </Typography>
  <Typography style={{ fontFamily: "'Playfair-Display, serif", fontSize: "21px", fontWeight: 500, WebkitFontSmoothing: "antialiased", MozOsxFontSmoothing: "grayscale" }} paragraph>
    Some Wolfe features may require payment. You will be notified of any applicable fees before subscribing.
  </Typography>
  <ul>
    <li>
      <Typography style={{ fontFamily: "'Playfair-Display, serif", fontSize: "21px", fontWeight: 500, WebkitFontSmoothing: "antialiased", MozOsxFontSmoothing: "grayscale" }}>
        Subscription plans auto-renew unless canceled in advance.
      </Typography>
    </li>
    <li>
      <Typography style={{ fontFamily: "'Playfair-Display, serif", fontSize: "21px", fontWeight: 500, WebkitFontSmoothing: "antialiased", MozOsxFontSmoothing: "grayscale" }}>
        Payments are non-refundable unless required by applicable law.
      </Typography>
    </li>
  </ul>
</Box>

<Box mb={3}>
  <Typography style={{ fontFamily: "'Lato', sans-serif", fontWeight: 600, fontSize: "25px" }} variant="h5" gutterBottom>
    7. Service Modifications & Termination
  </Typography>
  <Typography style={{ fontFamily: "'Playfair-Display, serif", fontSize: "21px", fontWeight: 500, WebkitFontSmoothing: "antialiased", MozOsxFontSmoothing: "grayscale" }} paragraph>
    We may update, modify, or discontinue Wolfe’s services at any time. We reserve the right to suspend or terminate your access if you violate these Terms.
  </Typography>
</Box>

<Box mb={3}>
  <Typography style={{ fontFamily: "'Lato', sans-serif", fontWeight: 600, fontSize: "25px" }} variant="h5" gutterBottom>
    8. Limitation of Liability
  </Typography>
  <Typography style={{ fontFamily: "'Playfair-Display, serif", fontSize: "21px", fontWeight: 500, WebkitFontSmoothing: "antialiased", MozOsxFontSmoothing: "grayscale" }} paragraph>
    Wolfe is provided "as is" without warranties of any kind. You acknowledge that:
  </Typography>
  <ul>
    <li>
      <Typography style={{ fontFamily: "'Playfair-Display, serif", fontSize: "21px", fontWeight: 500, WebkitFontSmoothing: "antialiased", MozOsxFontSmoothing: "grayscale" }}>
        We are not liable for any decisions made based on AI-generated content.
      </Typography>
    </li>
    <li>
      <Typography style={{ fontFamily: "'Playfair-Display, serif", fontSize: "21px", fontWeight: 500, WebkitFontSmoothing: "antialiased", MozOsxFontSmoothing: "grayscale" }}>
        Our total liability will not exceed the amount you paid for our services in the past six months.
      </Typography>
    </li>
  </ul>
</Box>

<Box mb={3}>
  <Typography style={{ fontFamily: "'Lato', sans-serif", fontWeight: 600, fontSize: "25px" }} variant="h5" gutterBottom>
    9. Dispute Resolution
  </Typography>
  <Typography style={{ fontFamily: "'Playfair-Display, serif", fontSize: "21px", fontWeight: 500, WebkitFontSmoothing: "antialiased", MozOsxFontSmoothing: "grayscale" }} paragraph>
    Any disputes arising from these Terms will be governed by the laws of Delaware. Disputes will be resolved through arbitration or legal action in Delaware.
  </Typography>
</Box>

<Box mb={3}>
  <Typography style={{ fontFamily: "'Lato', sans-serif", fontWeight: 600, fontSize: "25px" }} variant="h5" gutterBottom>
    10. Changes to These Terms
  </Typography>
  <Typography style={{ fontFamily: "'Playfair-Display, serif", fontSize: "21px", fontWeight: 500, WebkitFontSmoothing: "antialiased", MozOsxFontSmoothing: "grayscale" }} paragraph>
    We may update these Terms from time to time. If we make significant changes, we will notify you via Wolfe’s platform.
  </Typography>
</Box>

<Box mb={3}>
  <Typography style={{ fontFamily: "'Lato', sans-serif", fontWeight: 600, fontSize: "25px" }} variant="h5" gutterBottom>
    11. Contact Us
  </Typography>
  <Typography style={{ fontFamily: "'Playfair-Display, serif", fontSize: "21px", fontWeight: 500, WebkitFontSmoothing: "antialiased", MozOsxFontSmoothing: "grayscale" }} paragraph>
    If you have any questions about these Terms, please contact us at support@hellowolfe.com.
  </Typography>
</Box>

<Typography style={{ fontFamily: "'Playfair-Display, serif", fontSize: "21px", fontWeight: 500, WebkitFontSmoothing: "antialiased", MozOsxFontSmoothing: "grayscale" }} paragraph>
  <strong>By using Wolfe, you acknowledge that you have read, understood, and agreed to these Terms of Service.</strong></Typography>

        
      </Container>
    </div>
  );
}

export default TermsOfServiceConsumer;

